export default __webpack_public_path__ + "static/media/no holiday 2.8530f479.png";